import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type {
  Cashier,
  CreateUpdateCashierRequest,
} from "@/services/sharedTypes/cashiers"
import { BASE_CASHIERS_QUERY_KEY } from "@/services/queryKeys"

export const createCashier = async (
  params: CreateUpdateCashierRequest
): Promise<Cashier> => {
  const response = await api.post<Cashier>("/cashiers/", {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })

  return response.body
}
